var map = {
	"./demos/basic/index.ts": 45932,
	"./demos/checkbox/index.ts": 16629,
	"./demos/filter/index.ts": 22978,
	"./demos/load/index.ts": 55605,
	"./demos/multiple/index.ts": 82126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88696;